const columns = [
  {
    title: '热点栏目',
    links: [
      { label: '今日瓜榜', href: '#hot' },
      { label: '明星八卦', href: '#star' },
      { label: '社会热点', href: '#social' },
      { label: '编辑精选', href: '#feature' },
    ],
  },
  {
    title: '平台指南',
    links: [
      { label: '吃瓜答疑', href: '#faq' },
      { label: '关于我们', href: '#about' },
      { label: '线索投稿', href: '#contact' },
      { label: '返回顶部', href: '#top' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-secondary-100">
      <div className="mx-auto max-w-[1320px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.6fr_1fr_1fr]">
          <div>
            <a href="#top" className="inline-flex items-center gap-2.5" aria-label="吃瓜视界 首页">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-flashlight-fill text-xl text-background-50" style={{ width: 22, height: 22 }} />
              </span>
              <span className="font-heading text-2xl font-black tracking-tight text-foreground-950">吃瓜视界</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一站式吃瓜视频与娱乐资讯聚合门户，明星八卦、社会热点、影视综艺一手速递，热门瓜料实时更新，高清娱乐内容随心看个够。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {['ri-weibo-fill', 'ri-wechat-fill', 'ri-douban-fill', 'ri-bilibili-fill'].map((icon) => (
                <a
                  key={icon}
                  href="#contact"
                  aria-label="官方社交账号"
                  className="flex h-9 w-9 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
                >
                  <i className={icon} style={{ width: 17, height: 17, fontSize: 17 }} />
                </a>
              ))}
            </div>
          </div>

          {columns.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="font-heading text-base font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-background-300/70 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 吃瓜视界 · 一站式娱乐资讯内容平台</p>
          <p className="inline-flex items-center gap-1.5">
            <i className="ri-shield-check-line text-accent-700" style={{ width: 14, height: 14 }} />
            内容经多源核验发布 · 尊重版权与当事人权益
          </p>
        </div>
      </div>
    </footer>
  );
}